// 基础地址信息接口
export interface AddressInfo {
  companyName: string
  streetAddress: string
  city: string
  state: string
  zip: string
  country: string
  contactName: string
  phone: string
  email: string
  facility: string
  specialInstructions: string
}

export interface TimeInfo_1{
  deliveryTime:string
}

// 时间信息接口
export interface TimeInfo {
  pickupDate: string
  pickupTime: string
  closeDate: string
  closeTime: string
}

// 起始地服务类型枚举
export enum OriginService {
  AirportPU = '100P',
  Appointment = 'APTP',
  CFSPickup = 'CFSP',
  ConstructionSite = 'CONTRUCP',
  HazardousMaterial = 'HAZP',
  HospitalPickup = 'HOSPPICK',
  InsidePickup = 'IPU',
  Liftgate = 'LFTP',
  LimitedAccessPickup = 'ACHP',
  MineSitePickup = 'MSP',
  Notification = 'APTN',
  ProtectFromFreezing = 'PSCP',
  ResidentialPickup = 'REP',
  TeamTransit = 'DDP',
  TarpFee = 'TARP',
}

// 目的地服务类型枚举
export enum DestinationService {
  AirportDEL = '100D',
  Appointment = 'APTD',
  CFS = 'CFSD',
  ChurchDelivery = 'CHUD',
  ConstructionSite = 'CONTRUCD',
  DriverAssist = 'DRVRASTD',
  GroceryWarehouse = 'GWHSED',
  InsideDelivery = 'IDL',
  Liftgate = 'LFTD',
  LimitedAccess = 'ACHD',
  LumperFee = 'LUMPERDE',
  MineSiteDelivery = 'MSD',
  OverLength12 = 'OVR12TO16',
  OverLength16 = 'OVR16TO20',
  OverLength20 = 'OVR20',
  OverLength8 = 'OVR8TO12',
  PalletJack = 'PLTJACKD',
  ProtectFromFreezing = 'PSCD',
  ResidentialDelivery = 'RESD',
  ResidentialAppointment = 'RESDFA',
  SortAndSeg = 'SEGD',
  TradeShow = 'EBD',
  MallDelivery = 'MALLD',
  StopCharge = 'STD',
}

// 其他服务类型枚举
export enum OtherService {
  Fuel = 'FUEL',
  OversizeCharge = 'OVRC',
  SingleShipment = 'SSF',
  HighCostArea = 'HCAREA',
  HighCostAreaFee = 'HCDFEE',
  UpliftMinMax = 'UPLFT',
  TimeCriticalWindow = 'TCSW',
  GuaranteedServiceDay = '680RVDAY',
  LumperStop1 = 'LMPSTP1',
  LumperStop2 = 'LMPSTP2',
  LumperStop3 = 'LMPSTP3',
  LumperStop4 = 'LMPSTP4',
  LumperStop5 = 'LMPSTP5',
  LumperStop6 = 'LMPSTP6',
  LumperStop7 = 'LMPSTP7',
  LumperStop8 = 'LMPSTP8',
  LumperStop9 = 'LMPSTP9',
  LumperStop10 = 'LMPSTP10',
}

// 起始地信息接口
export interface OriginInfo extends AddressInfo, TimeInfo {
  services: OriginService[]
}

// 目的地信息接口
export interface DestinationInfo extends AddressInfo,TimeInfo_1 {
  services: DestinationService[]
}

// 新增商品维度接口
export interface CommodityDimensions {
  length: number
  width: number
  height: number
  dimensionsIN: {
    length: number
    width: number
    height: number
  }
}

// 新增商品信息接口
export interface CommodityInfo {
  handlingUnit: number
  packageType: PackagingType
  pieces: number
  description: string
  dimensions: CommodityDimensions
  weight: number
  weightIN: number
  class: number
  lf: number
  nmfc: string
  hazmat: boolean
  markings?: string
  hasStackable: boolean
  hazmatDesc?: string
  editing?: boolean
  unNumber?: string
  packingGroup?: number | undefined
  cbf?: number
  cm?: number
  pcf?: number
  /** 托盘常规尺寸预设（仅前端快捷输入，48x40 / 48x48 / 60x48 / custom） */
  palletSizePreset?: string
}
export interface Goods {
  units: number
  handlingQuantity: number
  packagingType: string
  goodLength: number
  goodWidth: number
  goodHeight: number
  weightTotal: number
  hasHazmat: boolean
  hasMachinery: boolean
  pieces: number
  freightClass: number
  linearFoot: number
  nmfcCode: string
  goodName: string
  hasStackable: boolean
  goodMarking?: string
  hasUsed: boolean
  hazmatDesc: string
  packingGroup: number | undefined
}

interface Accessorial {
  accessorialCode: string
  accessorialName?: string
  accessorialDesc?: string
  accessorialType: number
}
// 完整表单数据接口
export interface ShipmentQuoteForm {
  shipmentType: string
  userId: number | undefined
  origin: OriginInfo
  destination: DestinationInfo
  commodity: CommodityInfo
  commodities: CommodityInfo[]
  isMetric: boolean
  hasHazmat: boolean
  customerPO: string
  shipperReference: string

}

// 在文件末尾添加以下接口定义

export interface Quote {
  providerCode: string
  quote_cache_id: string
  providerQuoteId: string
  quoteId: number
  carrierCode: string
  carrierName: string
  tariffDescription: string
  serviceLevel: string
  serviceLevelDescription: string
  transitTime?: number
  usedLiabilityCoverage?: number
  newLiabilityCoverage?: number
  machineryCarrierLiabilityAmount?: number
  priceLineHaul: number
  priceFuelSurcharge?: number
  accessorials: number
  priceTotal: number
  quoteNumber?: string
  deliveryDate?: string
  effectiveDate?: string
  expirationDate?: string
  pricingInstructions?: string
  notes?: string[]
  hasUnprocessed?: boolean
  remark?: string
  ms: number
}
interface PriceAccessorial {
  accessorialCode: string
  accessorialPrice: number
}

export interface QuoteItem {
  quoteId: number
  apiQuoteNumber: string
  providerQuoteId: string
  providerCode: string
  cacheId: string
  carrierName: string
  carrierCode: string
  serviceLevel: string
  serviceLevelDescription: string
  transitTime: number
  priceLineHaul: number
  priceFuelSurcharge: number
  priceTotal: number
  usedLiabilityCoverage: number
  newLiabilityCoverage: number
  pricingInstructions: string
  tariffDescription: string
  priceAccessorials: PriceAccessorial[]
  hasUnprocessed?: boolean
  remark?: string
  priceAccessorial?: number
  ms: number
}

interface SmartQuoteResponseData {
  list: QuoteItem[]
  quoteId: number
}

export interface SmartQuoteResponse {
  code: number
  message: string
  data: SmartQuoteResponseData
  // Array<{
  //   provider_id: number
  //   quote_cache_id: string
  //   quoteId: string
  //   carrierCode: string
  //   carrierName: string
  //   tariffDescription: string
  //   serviceLevel: string
  //   serviceLevelDescription: string
  //   transitTime?: number
  //   usedLiabilityCoverage?: number
  //   newLiabilityCoverage?: number
  //   machineryCarrierLiabilityAmount?: number
  //   priceLineHaul: number
  //   priceFuelSurcharge?: number
  //   priceAccessorials: Array<{
  //     accessorialCode: string
  //     accessorialPrice?: number
  //   }>
  //   priceTotal: number
  //   quoteNumber?: string
  //   deliveryDate?: string
  //   effectiveDate?: string
  //   expirationDate?: string
  //   pricingInstructions?: string
  // }>
}

export enum WeightUnits {
  Pounds = 'LBS',
  Kilograms = 'KG',
}

export enum DimensionUnits {
  Inches = 'IN',
  Centimeters = 'CM',
}

export enum PackagingType {
  AFrame = 298,
  Bags = 290,
  Bales = 303,
  Barrel = 20,
  Basket = 30,
  Batteries = 310,
  Bins = 309,
  Box = 40,
  BreakBulk = 170,
  Bundle = 45,
  Cans = 304,
  Cart = 297,
  Carton = 50,
  Case = 60,
  Chest = 70,
  Container = 190,
  Crate = 80,
  Cylinder = 90,
  Drum = 100,
  Gallons = 302,
  Gaylords = 294,
  HalfPallets = 296,
  Hopper = 299,
  Jerricans = 305,
  LiftVan = 281,
  Loose = 307,
  Package = 110,
  Pails = 291,
  Pallet = 120,
  Piece = 130,
  Racks = 306,
  Reel = 140,
  Roll = 260,
  Skid = 150,
  Stacks = 308,
  Totes = 292,
  Truckload = 285,
  Tube = 160,
  Tubs = 301,
  UBox = 295,
  Unit = 280,
  Vehicle = 300,
  Wheels = 293,
}

// 默认值
export const DEFAULT_FORM: ShipmentQuoteForm = {
  shipmentType: 'LTL',
  userId: undefined,
  origin: {
    companyName: '',
    streetAddress: '',
    city: '',
    state: '',
    zip: '',
    country: 'USA',
    pickupDate: '',
    pickupTime: '',
    closeDate: '',
    closeTime: '',
    services: [],
    contactName: '',
    phone: '',
    email: '',
    facility: '',
    specialInstructions: '',
  },
  destination: {
    companyName: '',
    streetAddress: '',
    city: '',
    state: '',
    zip: '',
    country: 'USA',
    services: [],
    contactName: '',
    phone: '',
    email: '',
    facility: '',
    specialInstructions: '',
    deliveryTime:''
  },
  commodity: {
    handlingUnit: 0,
    packageType: PackagingType.Pallet,
    pieces: 1,
    description: '',
    dimensions: {
      length: 0,
      width: 0,
      height: 0,
      dimensionsIN: {
        length: 0,
        width: 0,
        height: 0,
      },
    },
    weight: 0,
    weightIN: 0,
    class: 60,
    lf: 0,
    cbf: 0,
    cm: 0,
    pcf: 0,
    nmfc: '',
    hazmat: false,
    markings: '',
    hasStackable: false,
    hazmatDesc: '',
    packingGroup: undefined,
    unNumber: '',
    palletSizePreset: '48x40',
  },
  commodities: [],
  isMetric: false,
  hasHazmat: false,
  customerPO:'',
  shipperReference:""
}

// New interface for accessorial services
export interface AccessorialService {
  code: string
}
export interface QuoteHistoryDetailResponse {
  quoteId: number
  companyName: string
  streetAddress: string
  shipmentType: string
  hasStackable: boolean
  originZipCode: string
  originCity: string
  originState: string
  originCountry: string
  pickupDate: string
  pickupTime: string
  destinationZipCode: string
  destinationCity: string
  destinationState: string
  destinationCountry: string
  destinationCompanyName: string
  destinationStreetAddress: string
  weightUnits: string
  dimensionUnits: string
  goods: Goods[]
  accessorialList: Accessorial[]
}
// New interface for shipment items
export interface ShipmentItem {
  freightClass: string
  packagingType: string
  units: number
  handlingQuantity: number
  pieces: number
  totalWeight: number
  length: number
  width: number
  height: number
  isStackable: boolean
  isHazardous: boolean
  isUsed: boolean
  isMachinery: boolean
  description: string
  nmfcCode: string
  nmfcSubCode: string
  additionalMarkings: string
  unNumber: string
  packingGroup: number | undefined
}

// Update QuoteApiRequest interface to match the new structure
// export interface QuoteApiRequest {
//   shipmentType: string
//   originZipCode: string
//   originCity: string
//   originStateCode: string
//   originCountryCode: string
//   destinationZipCode: string
//   destinationCity: string
//   destinationStateCode: string
//   destinationCountryCode: string
//   pickupDate: string
//   items: ShipmentItem[]
//   weightUnit: WeightUnits
//   dimensionUnit: DimensionUnits
//   accessorialServices: AccessorialService[]
// }
export interface QuoteApiRequest {
  shipmentType: string
  userId: number | undefined
  originCity: string
  companyName: string
  streetAddress: string
  destinationCompanyName: string
  destinationStreetAddress: string
  originState: string
  originZipCode: string
  originCountry: string
  destinationCity: string
  destinationState: string
  destinationZipCode: string
  destinationCountry: string
  goods: Goods[]
  weightUnits: string
  dimensionUnits: string
  accessorialList: Accessorial[]
  pickupDate: string
  hasStackable: boolean
  hasHazmat: boolean
}
export interface QuoteHistoryItem {
  // id: string
  // uid: string
  // payload: string
  // quotes: Array<{
  //   provider_id: number
  //   quote_cache_id: string
  //   quoteId: string
  //   carrierCode: string
  //   carrierName: string
  //   tariffDescription: string
  //   serviceLevel: string
  //   serviceLevelDescription: string
  //   transitTime: number
  //   usedLiabilityCoverage: number
  //   newLiabilityCoverage: number
  //   priceLineHaul: number
  //   priceFuelSurcharge: number
  //   priceAccessorials: Array<{
  //     accessorialCode: string
  //     accessorialPrice: number
  //   }>
  //   priceTotal: number
  //   quoteNumber: string
  //   deliveryDate: string
  //   effectiveDate: string
  //   expirationDate: string
  //   pricingInstructions: string
  // }>
  // created_at: number

  id: number
  cacheId: string
  companyName: string
  streetAddress: string
  shipmentType: 'LTL' | string // 如果还有其他类型，可以添加
  originZipCode: string
  originCity: string
  originState: string
  originCountry: string
  pickupDate: string
  pickupTime: string
  weightUnits: 'LBS' | string // 如果还有其他单位，可以添加
  dimensionUnits: 'IN' | string // 如果还有其他单位，可以添加
  destinationZipCode: string
  destinationCity: string
  destinationState: string
  destinationCountry: string
  destinationCompanyName: string
  destinationStreetAddress: string
  createTime: string
  goodsCount: number
  priceCount: number
  timeStr: string
}

// export interface QuoteHistoryResponse {
//   code: number
//   message: string
//   data: {
//     total: number
//     quotes: QuoteHistoryItem[]
//   }
// }

export const hazmatDescOption = [
  {
    code: '1.1',
    englishDesc: 'Mass Explosive Hazard',
    chineseDesc: '有整体爆炸危险的物质和物品',
  },
  {
    code: '1.2',
    englishDesc: 'Projection Hazard',
    chineseDesc: '有迸射危险但无整体爆炸危险的物质和物品',
  },
  {
    code: '1.3',
    englishDesc: 'Fire and/or Minor Blast/Minor Projection Hazard',
    chineseDesc:
      '有燃烧危险并有局部爆炸危险或局部迸射危险或两者都有，但无整体爆炸危险的物质和物品',
  },
  {
    code: '1.4',
    englishDesc: 'Minor Explosion Hazard',
    chineseDesc: '无重大危险的物质和物品',
  },
  {
    code: '1.5',
    englishDesc: 'Very Insensitive with Mass Explosion Hazard',
    chineseDesc: '有整体爆炸危险的极不敏感物质',
  },
  {
    code: '1.6',
    englishDesc: 'Extremely Insensitive; No Mass Explosion Hazard',
    chineseDesc: '无整体爆炸危险的极不敏感物品',
  },
  {
    code: '2.1',
    englishDesc: 'Flammable Gases',
    chineseDesc: '易燃气体',
  },
  {
    code: '2.2',
    englishDesc: 'Nonflammable Gases',
    chineseDesc: '非易燃无毒气体',
  },
  {
    code: '2.3',
    englishDesc: 'Toxic Gases',
    chineseDesc: '毒性气体',
  },
  {
    code: '3',
    englishDesc: 'Flammable and Combustible Liquids',
    chineseDesc: '易燃液体',
  },
  {
    code: '4.1',
    englishDesc: 'Flammable Solids',
    chineseDesc: '易燃固体、自反应物质和固态退敏爆炸品',
  },
  {
    code: '4.2',
    englishDesc: 'Spontaneously Combustible',
    chineseDesc: '易于自燃的物质',
  },
  {
    code: '4.3',
    englishDesc: 'Dangerous When Wet',
    chineseDesc: '遇水放出易燃气体的物质',
  },
  {
    code: '5.1',
    englishDesc: 'Oxidizing Substances',
    chineseDesc: '氧化性物质',
  },
  {
    code: '5.2',
    englishDesc: 'Organic Peroxides',
    chineseDesc: '有机过氧化物',
  },
  {
    code: '6.1',
    englishDesc: 'Toxic Substances',
    chineseDesc: '毒性物质',
  },
  {
    code: '6.2',
    englishDesc: 'Infectious Substances',
    chineseDesc: '感染性物质',
  },
  {
    code: '7',
    englishDesc: 'Radioactive Material',
    chineseDesc: '放射性物质',
  },
  {
    code: '8',
    englishDesc: 'Corrosives',
    chineseDesc: '腐蚀性物质',
  },
  {
    code: '9',
    englishDesc: 'Miscellaneous',
    chineseDesc: '杂项危险物质和物品',
  },
]

export const packingGroupOption = [
  {
    code: '0',
    symbol: 'NA',
    desc: '非危险品',
  },
  {
    code: '1',
    symbol: 'I',
    desc: 'I级包装',
  },
  {
    code: '2',
    symbol: 'II',
    desc: 'II级包装',
  },
  {
    code: '3',
    symbol: 'III',
    desc: 'III级包装',
  },
]

export const services_by_frontend_code = [
  {
    frontend_code: 'APTD',
    chinese_name: '预约派送',
    english_name: 'Appointment DEL',
    service_direction: 2,
    providers: ['BOOST', 'P1', 'FOX', 'TQL', 'FF'],
  },
  {
    frontend_code: 'ACHD',
    chinese_name: '受限区域派送',
    english_name: 'Limited Access DEL',
    service_direction: 2,
    providers: ['BOOST', 'P1', 'FOX', 'TQL', 'FF'],
  },
  {
    frontend_code: 'LFTD',
    chinese_name: '升降尾板派送',
    english_name: 'Liftgate DEL',
    service_direction: 2,
    providers: ['BOOST', 'P1', 'FOX', 'TQL', 'FF'],
  },
  {
    frontend_code: 'RESD',
    chinese_name: '住宅地址派送',
    english_name: 'Residential DEL',
    service_direction: 2,
    providers: ['BOOST', 'P1', 'FOX', 'TQL', 'FF'],
  },
  {
    frontend_code: 'DISTDEL',
    chinese_name: '配送中心（派送）',
    english_name: 'Distribution Center',
    service_direction: 2,
    providers: ['FOX'],
  },
  {
    frontend_code: 'FAD',
    chinese_name: '农场 / 牧场派送',
    english_name: 'Farm/Ranch Delivery',
    service_direction: 2,
    providers: ['FOX'],
  },
  {
    frontend_code: 'GSD',
    chinese_name: '政府场地派送',
    english_name: 'Government Site Delivery',
    service_direction: 2,
    providers: ['FOX'],
  },
  {
    frontend_code: 'IRD',
    chinese_name: '印第安保留地派送',
    english_name: 'Indian Reservation Delivery',
    service_direction: 2,
    providers: ['FOX'],
  },
  {
    frontend_code: 'HAZP',
    chinese_name: '危险品（运输附加）',
    english_name: 'Hazardous Material',
    service_direction: 1,
    providers: ['BOOST', 'P1', 'FOX'],
  },
  {
    frontend_code: 'PSCP',
    chinese_name: '防冻防护',
    english_name: 'Protect from Freezing',
    service_direction: 1,
    providers: ['P1', 'FOX', 'TQL'],
  },
  {
    frontend_code: 'LUMPERDE',
    chinese_name: '装卸工服务费',
    english_name: 'Lumper Fee',
    service_direction: 1,
    providers: ['FOX'],
  },
  {
    frontend_code: 'PMT',
    chinese_name: '当日达附加费',
    english_name: 'Same Day Charge',
    service_direction: 2,
    providers: ['FOX'],
  },
  {
    frontend_code: 'SEE',
    chinese_name: '白手套尊享服务',
    english_name: 'White Glove Service',
    service_direction: 1,
    providers: ['FOX'],
  },
  {
    frontend_code: 'PSD',
    chinese_name: '监狱场地派送',
    english_name: 'Prison Delivery',
    service_direction: 2,
    providers: ['FOX'],
  },
  {
    frontend_code: '100P',
    chinese_name: '机场提货',
    english_name: 'Airport PU',
    service_direction: 1,
    providers: ['BOOST', 'P1', 'FOX'],
  },
  {
    frontend_code: 'APTP',
    chinese_name: '预约提货',
    english_name: 'Appointment PU',
    service_direction: 1,
    providers: ['BOOST', 'P1', 'FOX'],
  },
  {
    frontend_code: 'CONTRUCP',
    chinese_name: '工地提货',
    english_name: 'Construction Site PU',
    service_direction: 1,
    providers: ['P1', 'FOX'],
  },
  {
    frontend_code: 'DRVRASTP',
    chinese_name: '司机协助提货',
    english_name: 'Driver Assist PU',
    service_direction: 1,
    providers: ['FOX'],
  },
  {
    frontend_code: 'HOTELPU',
    chinese_name: '酒店提货',
    english_name: 'Hotel PU',
    service_direction: 1,
    providers: ['FOX'],
  },
  {
    frontend_code: 'IPU',
    chinese_name: '入仓提货',
    english_name: 'Inside Pickup',
    service_direction: 1,
    providers: ['BOOST', 'P1', 'FOX', 'TQL'],
  },
  {
    frontend_code: 'LFTP',
    chinese_name: '升降尾板提货',
    english_name: 'Liftgate PU',
    service_direction: 1,
    providers: ['BOOST', 'P1', 'FOX', 'TQL', 'FF'],
  },
  {
    frontend_code: 'ACHP',
    chinese_name: '受限区域提货',
    english_name: 'Limited Access PU',
    service_direction: 1,
    providers: ['BOOST', 'P1', 'FOX', 'TQL'],
  },
  {
    frontend_code: 'MILPU',
    chinese_name: '军事基地提货',
    english_name: 'Military Base PU',
    service_direction: 1,
    providers: ['BOOST', 'P1', 'FOX'],
  },
  {
    frontend_code: 'OVNP',
    chinese_name: '夜间闸口提货',
    english_name: 'Nightgate Pickup',
    service_direction: 1,
    providers: ['FOX'],
  },
  {
    frontend_code: 'APTN',
    chinese_name: '提货通知',
    english_name: 'Notification PU',
    service_direction: 1,
    providers: ['BOOST', 'P1', 'FOX'],
  },
  {
    frontend_code: 'PLTJACKP',
    chinese_name: '托盘车协助提货',
    english_name: 'Pallet Jack PU',
    service_direction: 1,
    providers: ['FOX'],
  },
  {
    frontend_code: 'REP',
    chinese_name: '住宅地址提货',
    english_name: 'Residential PU',
    service_direction: 1,
    providers: ['BOOST', 'P1', 'FOX', 'TQL', 'FF'],
  },
  {
    frontend_code: '670',
    chinese_name: '周六提货',
    english_name: 'Saturday Pickup',
    service_direction: 1,
    providers: ['P1', 'FOX'],
  },
  {
    frontend_code: 'SCHPU',
    chinese_name: '学校提货',
    english_name: 'School PU',
    service_direction: 1,
    providers: ['FOX'],
  },
  {
    frontend_code: 'PDSP',
    chinese_name: '仓储设施提货',
    english_name: 'Storage Facility PU',
    service_direction: 1,
    providers: ['FOX'],
  },
  {
    frontend_code: 'CFSP',
    chinese_name: '集装箱货运站取货',
    english_name: 'Container Freight Station Pickup',
    service_direction: 1,
    providers: ['BOOST', 'P1', 'FOX'],
  },
  {
    frontend_code: 'HOSPPICK',
    chinese_name: '医院取货',
    english_name: 'Hospital Pickup',
    service_direction: 1,
    providers: ['P1', 'FOX'],
  },
  {
    frontend_code: 'LABP',
    chinese_name: '双人团队提货',
    english_name: 'Two Man - PU',
    service_direction: 1,
    providers: ['P1', 'FOX'],
  },
  {
    frontend_code: 'MSP',
    chinese_name: '矿场取货',
    english_name: 'Mine Site Pickup',
    service_direction: 1,
    providers: ['P1', 'FOX'],
  },
  {
    frontend_code: 'TARP',
    chinese_name: '篷布费',
    english_name: 'Tarp Fee',
    service_direction: 1,
    providers: ['P1', 'FOX'],
  },
  {
    frontend_code: 'EBP',
    chinese_name: '展会提货',
    english_name: 'Trade Show PU',
    service_direction: 1,
    providers: ['P1', 'FOX', 'TQL', 'FF'],
  },
  {
    frontend_code: 'DDP',
    chinese_name: '团队运输',
    english_name: 'Team Delivery Pickup',
    service_direction: 1,
    providers: ['P1', 'FOX'],
  },
  {
    frontend_code: '100D',
    chinese_name: '机场派送',
    english_name: 'Airport DEL',
    service_direction: 2,
    providers: ['BOOST', 'P1', 'FOX', 'FF'],
  },
  {
    frontend_code: 'IDL',
    chinese_name: '入仓派送',
    english_name: 'Inside Delivery',
    service_direction: 2,
    providers: ['BOOST', 'P1', 'FOX', 'TQL'],
  },
  {
    frontend_code: 'MILDEL',
    chinese_name: '军事基地派送',
    english_name: 'Military Base DEL',
    service_direction: 2,
    providers: ['BOOST', 'P1', 'FOX'],
  },
  {
    frontend_code: 'CFSD',
    chinese_name: '集装箱货运站提货',
    english_name: 'Container Freight Station Delivery',
    service_direction: 2,
    providers: ['BOOST', 'P1', 'FOX'],
  },
  {
    frontend_code: '665',
    chinese_name: '周六派送',
    english_name: 'Saturday Delivery',
    service_direction: 2,
    providers: ['FOX'],
  },
  {
    frontend_code: 'CONTRUCD',
    chinese_name: '工地派送',
    english_name: 'Construction Site DEL',
    service_direction: 2,
    providers: ['P1', 'FOX', 'FF'],
  },
  {
    frontend_code: 'EBD',
    chinese_name: '展会派送',
    english_name: 'Trade Show DEL',
    service_direction: 2,
    providers: ['FOX', 'TQL', 'FF'],
  },
  {
    frontend_code: 'HOTELDEL',
    chinese_name: '酒店派送',
    english_name: 'Hotel DEL',
    service_direction: 2,
    providers: ['FOX'],
  },
  {
    frontend_code: 'LABD',
    chinese_name: '双人团队派送',
    english_name: 'Two Man - DEL',
    service_direction: 2,
    providers: ['P1', 'FOX'],
  },
  {
    frontend_code: 'PDSD',
    chinese_name: '仓储设施派送',
    english_name: 'Storage Facility DEL',
    service_direction: 2,
    providers: ['FOX'],
  },
  {
    frontend_code: 'PLTJACKD',
    chinese_name: '托盘车协助派送',
    english_name: 'Pallet Jack DEL',
    service_direction: 2,
    providers: ['FOX'],
  },
  {
    frontend_code: 'PSCD',
    chinese_name: '防冻保护',
    english_name: 'Protect from Freezing Delivery',
    service_direction: 2,
    providers: ['P1', 'FOX', 'TQL'],
  },
  {
    frontend_code: 'SCHDE',
    chinese_name: '学校派送',
    english_name: 'School DEL',
    service_direction: 2,
    providers: ['FOX', 'FF'],
  },
  {
    frontend_code: 'CHUD',
    chinese_name: '教堂配送',
    english_name: 'Church Delivery',
    service_direction: 2,
    providers: ['P1', 'FOX'],
  },
  {
    frontend_code: 'GWHSED',
    chinese_name: '超市仓库',
    english_name: 'Supermarket Warehouse Delivery',
    service_direction: 2,
    providers: ['P1', 'FOX'],
  },
  {
    frontend_code: 'MALLD',
    chinese_name: '商场配送',
    english_name: 'Mall Delivery',
    service_direction: 2,
    providers: ['P1', 'FOX'],
  },
  {
    frontend_code: 'MSD',
    chinese_name: '矿区派送',
    english_name: 'Mine Site Delivery',
    service_direction: 2,
    providers: ['P1', 'FOX'],
  },
  {
    frontend_code: 'NBD',
    chinese_name: '非营业时间派送',
    english_name: 'Non Business Hours Delivery',
    service_direction: 2,
    providers: ['P1', 'FOX'],
  },
  {
    frontend_code: 'OVR12TO16',
    chinese_name: '超长 - 12-16 英尺',
    english_name: 'Overlength - 12-16 Feet',
    service_direction: 2,
    providers: ['BOOST', 'P1', 'FOX'],
  },
  {
    frontend_code: 'OVR16TO20',
    chinese_name: '超长 - 16-20 英尺',
    english_name: 'Overlength - 16-20 Feet',
    service_direction: 2,
    providers: ['BOOST', 'P1', 'FOX'],
  },
  {
    frontend_code: 'OVR20',
    chinese_name: '超长 - 20 英尺以上',
    english_name: 'Overlength - 20 Feet Above',
    service_direction: 2,
    providers: ['BOOST', 'P1', 'FOX'],
  },
  {
    frontend_code: 'OVR8TO12',
    chinese_name: '超长 - 8-12 英尺',
    english_name: 'Overlength - 8-12 Feet',
    service_direction: 2,
    providers: ['BOOST', 'P1', 'FOX'],
  },
  {
    frontend_code: 'RESDFA',
    chinese_name: 'Forward Air 专属住宅预约',
    english_name: 'Forward Air Exclusive Residential Appointment',
    service_direction: 2,
    providers: ['P1', 'FOX'],
  },
  {
    frontend_code: 'SEGD',
    chinese_name: '分类配送',
    english_name: 'Segregated Delivery',
    service_direction: 2,
    providers: ['P1', 'FOX', 'TQL'],
  },
  {
    frontend_code: 'STD',
    chinese_name: '停靠费',
    english_name: 'Stop Fee',
    service_direction: 2,
    providers: ['FOX'],
  },
]
